(function () {
  const apiUrl =
    "https://v6-metadata-cf.simplestreamcdn.com/api/epg-nocache/now-next?key=6Pr3Uj2Fo3Ix7Rb9Ze9Ro4Ez2Eq7Sy&lang=en&cc=GB";

  function findCurrentProgram(sections) {
    const now = new Date();
    return sections.find(
      (tile) => now >= new Date(tile.start) && now < new Date(tile.end)
    );
  }

  function getProgramContainerPrefix(channelId) {
    switch (channelId) {
      case "553":
        return "bl-"; // Blaze TV (Broadcast SCTE)
      case "1227":
        return "ic-"; // Inside Crime
      case "1228":
        return "ms-"; // Mystery TV
      case "1229":
        return "ww-"; // World War TV
      case "1235":
        return "dm-"; // Deal Masters
      case "1236":
        return "hh-"; // History Hunters
      default:
        console.warn("Unknown FAST channel ID:", channelId);
        return "tv-"; // Default prefix
    }
  }

  function updateProgramDetails(programContainer, program) {
    const programImage = programContainer.querySelector("#c-program-image");
    const programTitle = programContainer.querySelector("#c-program-title");
    const programEpisodeTitle = programContainer.querySelector(
      "#c-program-episode-title"
    );
    const programStart = programContainer.querySelector("#c-program-start");
    const programEnd = programContainer.querySelector("#c-program-end");
    const programSeason = programContainer.querySelector("#c-program-season");
    const programEpisode = programContainer.querySelector("#c-program-episode");

    if (program) {
      if (programImage) {
        // Checks if program image exists before setting
        programImage.src = program.image;
      }
      if (programTitle) {
        // Checks if program title exists before setting
        programTitle.textContent = program.title;
      }
      if (programEpisodeTitle) {
        // Checks if episode title exists before setting
        programEpisodeTitle.textContent = program.episode_title;
      }
      // Formats the start time of the program to hh:mm
      if (programStart) {
        const startDate = new Date(program.start);
        const formattedStartTime = startDate.toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        });
        programStart.textContent = formattedStartTime;
      }

      // Formats the end time of the program to hh:mm
      if (programEnd) {
        const endDate = new Date(program.end);
        const formattedEndTime = endDate.toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        });
        programEnd.textContent = " - " + formattedEndTime;
      }
      if (programSeason && program.season) {
        programSeason.textContent = "Season: " + program.season;
      }
      if (programEpisode && program.episode) {
        programEpisode.textContent = " · Episode: " + program.episode;
      }
    } else {
      programTitle.textContent = "Channel currently off air";
      // Set a default title value if the information isn't available
    }
  }

  // Code execution wrapped in DOMContentLoaded event listener
  document.addEventListener("DOMContentLoaded", function () {
    fetch(apiUrl)
      .then((response) => response.json())
      .then((data) => {
        for (const section of data.response.sections) {
          const channelId = section.id;
          const elementIdPrefix = getProgramContainerPrefix(channelId);

          const program = findCurrentProgram(section.tiles);
          if (program) {
            const programContainer = document.getElementById(
              elementIdPrefix + "program-data"
            );

            if (programContainer) {
              updateProgramDetails(programContainer, program);
            } else {
              console.warn("Container not found for", elementIdPrefix);
            }
          } else {
            console.error(
              `No program found for FAST channel ${channelId} in API response.`
            );
          }
        }
      })
      .then(() => {
        var splide = new Splide("#live-slider", {
          type: "loop",
          perPage: 3,
          perMove: 1,
          gap: "20px",

          breakpoints: {
            992: {
              perPage: 2,
              gap: "10px",
            },
            768: {
              perPage: 1,
            },
          },
        });

        splide.mount();
      })
      .catch((error) => {
        console.error("Error fetching API FAST data:", error);
      });
  });
})();
